import React, { useState, useRef, useEffect } from "react";
import { history } from "../helpers/history";
import axios from "../api/index";
import YouTube from "react-youtube";
import { useParams } from "react-router-dom";
import { serverIP } from '../api/CONSTANTS';
import platform from "platform";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faVideo,
  faFile,
  faPenToSquare,
  faCircleQuestion,
  faArrowTurnDown,
  faFlipHorizontal,
} from "@fortawesome/free-solid-svg-icons";
// import Alert from "./Alert";
// Removed static WATCH_THRESHOLD_MS; now derived dynamically from video.minimum_watch (minutes) with a fallback.

class Session extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      results: [],
      loading: false,
      user: {},
      video: {},
      videoId: null, // sanitized YouTube video id
      // Use a numeric timestamp in ms when playback starts; null means not playing
      startPlay: null,
      playtime: 0,
      pausePlay: true,
      seconds: "",
      setSeconds: "",
      params: {},
      watchedflag: false,
    };
  }

  componentDidMount() {
    this.interval = setInterval(() => this.checkVideo(), 300000);

    const id = this.props.match.params.id;

    this.setState({
      loading: true,
    });

    let tokenString = sessionStorage.getItem("token");
    let userToken = JSON.parse(tokenString);
    let userString = sessionStorage.getItem("user");
    let currentUser = JSON.parse(userString);

    if (!currentUser) {
      this.setState({
        currentUser: null,
      });
      localStorage.removeItem("user");
      history.push("/home");
      sessionStorage.clear();
      window.location.reload();
    }
    if (!userToken) {
      this.setState({
        currentUser: null,
      });
      localStorage.removeItem("user");
      history.push("/home");
      sessionStorage.clear();
      window.location.reload();
    }

    this.setState({
      loading: true,
      user: currentUser,
    });

    this.fetchdata(id);
  }
  componentWillUnmount() {
    clearInterval(this.interval);
  }

  fetchdata(id) {
    let video = sessionStorage.getItem("video");

    // console.log(this.id);
    this.setState({
      loading: true,
    });
    return axios({
      url: `/api/video/${id}`,
    })
      .then((res) => {
        const incomingVideo = res.data.video;
        const videoId = incomingVideo.link
        this.setState({
          loading: false,
          video: incomingVideo,
          videoId,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
        if (err.response.status) {
          this.setState({
            video: false,
          });
        }
      });
  }
  changeDialog = (e, index) => {
    e.preventDefault();
    this.setState({
      activeIndex: index,
    });
  };

  startQuiz(quiz) {
    sessionStorage.setItem("quiz", quiz[0].id);
    history.push("/quiz");
    window.location.reload();
  }


  // Derive dynamic watch threshold (ms) from video.minimum_watch (minutes) with fallback 15 min.
  getWatchThresholdMs() {
    const { video } = this.state;
    const minutes = video && Number(video.accepted_watched_duration);
    if (!isNaN(minutes) && minutes > 0) return minutes * 60 * 1000;
    return 15 * 60 * 1000; // fallback 15 minutes
  }
  onReady = (value) => {
    //TODO:
  };
  onPlay = (value) => {
    // Only mark as playing if we were paused
    if (this.state.pausePlay) {
      this.setState({
        startPlay: Date.now(),
        pausePlay: false,
      });
    }
  };

  onPause = (value) => {
    // Accumulate only if we are currently playing and have a valid start timestamp
    if (!this.state.pausePlay && this.state.startPlay != null) {
      const now = Date.now();
      const delta = Math.max(0, now - this.state.startPlay);
      const total = this.state.playtime + delta;

      // Update state first
      this.setState({
        pausePlay: true,
        playtime: total,
        startPlay: null,
      });

      // Decide based on the computed total (not this.state.playtime which is async)
      if (total >= this.getWatchThresholdMs() && !this.state.watchedflag) {
        // Prevent duplicate calls immediately
        this.setState({ watchedflag: true }, () => this.wathedVideo());
      }
    }
  };

  onEnd = (value) => {
    // Treat end like a pause with accumulation
    if (this.state.startPlay != null) {
      const now = Date.now();
      const delta = Math.max(0, now - this.state.startPlay);
      const total = this.state.playtime + delta;

      this.setState({
        pausePlay: true,
        playtime: total,
        startPlay: null,
      });

      if (total >= this.getWatchThresholdMs() && !this.state.watchedflag) {
        this.setState({ watchedflag: true }, () => this.wathedVideo());
      }
    } else {
      // No start timestamp; ensure we're paused and do nothing
      this.setState({ pausePlay: true, startPlay: null });
    }
  };

  checkVideo() {
    // Periodically accumulate time without toggling pause/play events
    if (this.state.pausePlay === false && this.state.startPlay != null) {
      const now = Date.now();
      const delta = Math.max(0, now - this.state.startPlay);
      const total = this.state.playtime + delta;

      // Roll the start window forward to now so we don't double count
      this.setState({ playtime: total, startPlay: now });

      if (total >= this.getWatchThresholdMs() && !this.state.watchedflag) {
        this.setState({ watchedflag: true }, () => this.wathedVideo());
      }
    }
  }

  wathedVideo() {
    this.setState({
      loading: true,
    });
    const { user, video } = this.state;
    return axios({
      url: `/api/watched`,
      body: {
        user: user.id,
        video: video.id,
        platform: platform.name,
      },
      method: "POST",
    })
      .then((res) => {
        if (res.data[0] === "success") this.setState({ watchedflag: true });

        this.setState({
          loading: false,
          playtime: 0,
        });
      })
      .catch((err) => {
        this.setState({
          loading: false,
        });
      });
  }
  // Window.addEventListener('beforeunload', function (e) {
  //     // Cancel the event
  //     e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
  //     this.wathedVideo();
  //    return e.returnValue = '';
  //   });
  render() {
    const { video, videoId } = this.state;
    const thresholdMs = this.getWatchThresholdMs();
    const watchedEnough = this.state.playtime >= thresholdMs || this.state.watchedflag || video.attended === "all" || video.attended === "half";
    return (
      <div className="container-fluid">
        {!video && (
          <h1 className="alert alert-danger text-center">
            ...حدث خطأ! من فضلك أعد تحميل الصفحة أو تأكد من الرابط
          </h1>
        )}
        {video && (
          <div className="row">
            <div className="col-lg-3 col-md-4 ml-auto">
              {/* Side navbar */}
              <nav className="side-navbar">
                <ul className="navbar-nav">
                  <li className="nav-item">
                    <a className="nav-link" href="#video">
                      مشاهدة الفيديو
                      <FontAwesomeIcon
                        icon={faVideo}
                        style={{ marginLeft: "8px" }}
                      />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#exam"
                      style={{ marginLeft: "33px" }}
                    >
                      ابدأ الامتحان
                      <FontAwesomeIcon
                        icon={faPenToSquare}
                        style={{ marginLeft: "8px" }}
                      />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a className="nav-link" href="#files">
                      ملفات المحاضرة
                      <FontAwesomeIcon
                        icon={faFile}
                        style={{ marginLeft: "8px" }}
                      />
                    </a>
                  </li>
                  <li className="nav-item">
                    <a
                      className="nav-link"
                      href="#question"
                      style={{ marginLeft: "42px" }}
                    >
                      ارسل سؤال
                      <FontAwesomeIcon
                        icon={faCircleQuestion}
                        style={{ marginLeft: "10px" }}
                      />
                    </a>
                  </li>
                </ul>
              </nav>
            </div>

            <div className="container">
              <div className="row justify-content-center" id="video">
                {video && video.title && (
                  <p className="video-title">{video.title}</p>
                )}
                {video && video.speaker && (
                  <p className="video-speaker">{video.speaker}</p>
                )}
                <div className="video-container" id="exam">
                  <div className="video-frame">
                    {!videoId && (
                      <div className="text-center" style={{ padding: "40px" }}>
                        <div className="spinner-border text-primary" role="status">
                          <span className="sr-only">Loading...</span>
                        </div>
                        <p style={{ marginTop: "10px" }}>...جاري تحميل الفيديو</p>
                      </div>
                    )}
                    {videoId && (
                      <YouTube
                        videoId={videoId}
                        id={videoId}
                        onReady={this.onReady}
                        onPlay={this.onPlay}
                        onPause={this.onPause}
                        onEnd={this.onEnd}
                        onError={this.onError}
                        onStateChange={this.onStateChange}
                      />
                    )}
                  </div>
                </div>
                <div
                  className="col-lg-12 col-md-12 center-content"
                  style={{ marginTop: "5%" }}
                >
                  {!watchedEnough && (
                    <>
                      <button
                        className="btn btn-primary btn-lg btn-block btn-warning"
                        onClick={() => {
                          alert(
                            "سيكون الامتحان متاح لك عند مشاهدة الحد الأدنى من زمن الفيديو المحدد.. قم بتوقيف الفيديو (pause) ثم أعد تحميل الصفحة بعد انتهائك."
                          );
                          this.checkVideo();
                        }}
                      >
                        ابدأ الامتحان
                      </button>
                    </>
                  )}
                  {watchedEnough && (
                    <button
                      className="btn btn-success btn-lg btn-block"
                      onClick={() => {
                        this.startQuiz(video.quizzes);
                      }}
                      style={{ width: "100%" }}
                    >
                      <span>
                        ابدأ الامتحان{" "}
                        <FontAwesomeIcon
                          icon={faPenToSquare}
                          style={{ marginLeft: "5px" }}
                        />
                      </span>
                    </button>
                  )}
                </div>
                {/* Files section */}
                <div className="card text-center" id="files">
                  <div
                    className="card-header text-center text-white"
                    style={{ backgroundColor: "#646ecb" }}
                  >
                    ملفات المحاضرة
                    <FontAwesomeIcon
                      icon={faFile}
                      className="mr-2"
                      style={{ marginLeft: "8px" }}
                    />
                  </div>
                  <div className="card-body">
                    {video && video.pdf && (
                      <iframe
                        src={`${serverIP}/storage/${video.pdf}`}
                        width="100%"
                        height="700px"
                      ></iframe>
                    )}
                  </div>
                </div>
                {/* Question section */}
                <div className="card" id="question">
                  <div
                    dir="rtl"
                    style={{ backgroundColor: "#646ecb" }}
                    className="card-header text-center text-white"
                  >
                    لو عندك سؤال في المحاضرة ابعته هنا
                    <FontAwesomeIcon
                      icon={faArrowTurnDown}
                      className="fa-flip-horizontal"
                      style={{ marginRight: "8px" }}
                    />
                  </div>
                  <div className="card-body">
                    <iframe
                      src="https://docs.google.com/forms/d/e/1FAIpQLSfHeIvCTR1YGHfcGtQR9VzSN0hRYsd5-o502vIKwE07GDCtzA/viewform?embedded=true"
                      width="100%"
                      height="425"
                      frameBorder="0"
                      marginHeight="0"
                      marginWidth="0"
                    >
                      Loading…
                    </iframe>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

// window.addEventListener('beforeunload', function (e) {
//   // Cancel the event
//   e.preventDefault(); // If you prevent default behavior in Mozilla Firefox prompt will always be shown
//   // Chrome requires returnValue to be set
//   e.returnValue = '';
//   return 1;

// });

export default Session;
